export const componentType = 'Column';
